"use client";

export interface MenuItem {
  id: string;
  label: string;
  href: string;
  order: number;
  visible: boolean;
}

const STORAGE_KEY = 'wg_nav_menu_items';

export const defaultMenuItems: MenuItem[] = [
  { id: '1', label: 'Find a Cause', href: '/homepage', order: 1, visible: true },
  { id: '2', label: 'How It Works', href: '/homepage#how-it-works', order: 2, visible: true },
  { id: '3', label: 'Charity Partners', href: '/charity-partner-portal', order: 3, visible: true },
  { id: '4', label: 'Blog', href: '/homepage#blog', order: 4, visible: true },
];

export function getMenuItems(): MenuItem[] {
  if (typeof window === 'undefined') return defaultMenuItems;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return JSON.parse(stored) as MenuItem[];
  } catch {
    // ignore
  }
  return defaultMenuItems;
}

export function saveMenuItems(items: MenuItem[]): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}
